<template>
	<core-modal :name="`${provider.slug}-no-access-integration`" class="om-pro-feature integration" :width="1000">
		<modals-header :name="`${provider.slug}-no-access-integration`" />

		<modals-content>
			<h2>Upgrade to Unlock the {{ provider.name }} Integration and So Much More!</h2>
			<p>Here are just a few of the solutions you’re missing out on…</p>

			<div class="omapi-get-pro__features">
				<ul class="omapi-list omapi-list__twocol">
					<li class="omapi-list__item omapi-success">Exit-Intent®</li>
					<li class="omapi-list__item omapi-success">Campaign Scheduling</li>
					<li class="omapi-list__item omapi-success">Gamified Spin To Win Campaigns</li>
					<li class="omapi-list__item omapi-success">Countdown Timers</li>
					<li class="omapi-list__item omapi-success">Content Locking</li>
					<li class="omapi-list__item omapi-success">A/B Split Testing</li>
				</ul>
			</div>
			<core-upgrade-button color="green" size="monster" utm-medium="Integrations">
				Upgrade Now To Access This Integration
			</core-upgrade-button>
			<core-upgrade-button :link-style="true" :arrow="true" utm-medium="Integrations"
				>Learn more about all features</core-upgrade-button
			>
		</modals-content>
	</core-modal>
</template>

<script>
export default {
	props: {
		/**
		 * Provider
		 */
		provider: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="scss">
@import '../../../assets/scss/variables';
.om-pro-feature {
	.header {
		background-color: transparent !important;
		padding: 30px 30px 0 !important;

		.close {
			button {
				color: #b2b4b8;
			}
		}
	}

	.content {
		align-items: center;
		display: flex;
		flex-direction: column;
		padding: 0 100px 40px !important;

		h2 {
			font-weight: $font_bold;
			text-align: center;
			font-size: 24px;
			line-height: 140%;
			margin-top: 10px;
		}

		p {
			font-size: 16px;
			text-align: center;
			padding: 0 35px;
			width: 560px;
		}

		.omapi-list__twocol {
			justify-content: flex-end;
			.omapi-list__item {
				color: $color_black;
				margin-bottom: 16px;
				display: flex;
				align-items: center;
				flex: 0 0 45%;
			}
		}

		.omapi-button.omapi-button__monster {
			margin: 18px 0 24px;
			line-height: 100%;
		}

		.omapi-button__link {
			font-size: 14px;
			line-height: 130%;
		}
	}
}
</style>
